module.exports = __webpack_public_path__ + "img/cloud-necklace-1.2b4a0407.jpg";